import { DeceasedReligion } from './deceasedReligion';

//* 고인 추가 이름(세례명·법명) 규칙 — 2026-11-02 (사용자 결정: 저장은 깨끗이 분리, 합성은 표시 쪽에서)
//* - 저장: `deceasedInfo.name`=본명, `deceasedInfo.nameDetail`=세례명·법명 (둘 다 기존 스키마 필드, 백엔드 무수정)
//* - 표시: 공유 문구·카카오·부고 카드·답례 등 "홍길동 어거스틴"이 필요한 곳은 deceasedFullName()으로 합성
//*   (정산·관리자 목록·셀러 화면은 본명(name)만 — 식별 용도라 그대로 둠)
//* - 옛 데이터: 성함 칸에 "홍길동 어거스틴"으로 같이 적어 둔 상가는 nameDetail이 비어 있어 name 그대로 나온다(의도된 동작)
//* - splitDeceasedName의 접미사 분리는 name에 추가 이름이 중복 포함된 비정상 데이터 방어용(새 저장분은 이미 분리돼 있음)

export interface DeceasedNameParts {
  baseName: string;
  extraName: string;
}

export const splitDeceasedName = (info: {
  name?: string;
  nameDetail?: string;
}): DeceasedNameParts => {
  const name = (info.name ?? '').trim();
  const extraName = (info.nameDetail ?? '').trim();
  if (!extraName) return { baseName: name, extraName: '' };
  const suffix = ` ${extraName}`;
  const baseName = name.endsWith(suffix) ? name.slice(0, -suffix.length).trim() : name;
  return { baseName, extraName };
};

export const composeDeceasedName = (baseName: string, extraName?: string) =>
  [baseName.trim(), (extraName ?? '').trim()].filter(Boolean).join(' ');

/** 표시·문구용 전체 이름 "홍길동 어거스틴". name에 이미 포함돼 있으면 중복 안 붙임 */
export const deceasedFullName = (info?: {
  name?: string;
  nameDetail?: string;
}): string => {
  if (!info) return '';
  const { baseName, extraName } = splitDeceasedName(info);
  return composeDeceasedName(baseName, extraName);
};

//* 종교별 추가 이름 명칭 — 입력 칸 안내용. 부고장엔 표기하지 않는다(입력값이 세례명·법명·직책 중 무엇인지 알 수 없음)
export const religiousNameLabel = (religion?: DeceasedReligion): string => {
  if (religion === 'catholic' || religion === 'christian') return '세례명';
  if (religion === 'buddhist') return '법명';
  return '';
};
